// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#other-office-online-meetings[data-v-6aaab515]{max-width:1292px;margin-left:auto;margin-right:auto}#other-office-online-meetings .box-header[data-v-6aaab515]{padding-bottom:0!important}#other-office-online-meetings .box-body .tab-title[data-v-6aaab515]{position:relative;max-height:23px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
